export {AppNeedsComponent} from "./app-needs/app-needs.component";
export {DigitalPlatformComponent} from "./digital-platform/digital-platform.component";



// WEBPACK FOOTER //
// ./src/components/index-page/export.js